import React, { useState, useEffect } from 'react';
import {
	Container,
	Box,
	Button,
	Divider,
	Grid,
	useTheme,
	useMediaQuery,
} from '@mui/material';
import Header from '../components/resuableComponents/Header';
import Footer from '../components/resuableComponents/Footer';
import Login from '../components/resuableComponents/Login';
import bac from '../assets/images/bac.jpg';
import { AutoComplete } from 'antd';
import moment from 'moment';
import { DatePicker, Space } from 'antd';
import type { DatePickerProps } from 'antd';
import {
	AddSearchFlightDispatch,
	fetchCityDispatch,
	fetchHotel,
} from '../reducers/HomeReducer';
import { DownOutlined } from '@ant-design/icons';
import type { MenuProps } from 'antd';
import { Dropdown, message } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { Modal } from 'antd';
import { useNavigate } from 'react-router-dom';
import {
	setSelectedArrival,
	setSelectedDepart,
	setTab,
} from '../reducers/UiReducer';
import Carousels from '../components/resuableComponents/Carousels';
import { AddSearchFlightFDDispatch } from '../reducers/FDReducer';
import SearchEngneBus from '../components/resuableComponents/SearchEngneBus';
import { fetchBusCityDispatch } from '../reducers/BusReducer';
import SearchEngineHotel from '../components/resuableComponents/SearchEngineHotel';
import Navbar from '../components/resuableComponents/Navbar/Navbar';
import SliderPage from '../components/resuableComponents/SliderPage';
const Option = AutoComplete.Option;
const items: MenuProps['items'] = [
	{
		label: '1st menu item',
		key: '1',
	},
	{
		label: '2nd menu item',
		key: '2',
	},
	{
		label: '3rd menu item',
		key: '3',
	},
];
const popularFlight = [
	{
		name: 'Indigo Airlines',
		image: 'https://images.ixigo.com/img/common-resources/airline-new/6E.png',
	},
	{
		name: 'Air India',
		image: 'https://images.ixigo.com/img/common-resources/airline-new/AI.png',
	},
	{
		name: 'Air India Express',
		image: 'https://images.ixigo.com/img/common-resources/airline-new/IX.png',
	},
	{
		name: 'Air Asia India',
		image: 'https://images.ixigo.com/img/common-resources/airline-new/I5.png',
	},
	{
		name: 'Akasa Air',
		image: 'https://images.ixigo.com/img/common-resources/airline-new/QP.png',
	},
	{
		name: 'Vistara Airline',
		image: 'https://images.ixigo.com/img/common-resources/airline-new/UK.png',
	},
	{
		name: 'SpiceJet',
		image: 'https://images.ixigo.com/img/common-resources/airline-new/SG.png',
	},
];
const popularDes = [
	{
		image:
			'https://images.ixigo.com/image/upload/flightshome/79ee38cdbe961dccc3474b0bb92a3e06-nehrw.png',
		name: 'Mumbai Flights',
		to: ['Goa', 'Delhi', 'Banglore', 'Ahmedabad'],
	},
	{
		image:
			'https://images.ixigo.com/image/upload/flightshome/79ee38cdbe961dccc3474b0bb92a3e06-nehrw.png',
		name: 'Mumbai Flights',
		to: ['Goa', 'Delhi', 'Banglore', 'Ahmedabad'],
	},
	{
		image:
			'https://images.ixigo.com/image/upload/flightshome/79ee38cdbe961dccc3474b0bb92a3e06-nehrw.png',
		name: 'Mumbai Flights',
		to: ['Goa', 'Delhi', 'Banglore', 'Ahmedabad'],
	},
	{
		image:
			'https://images.ixigo.com/image/upload/flightshome/79ee38cdbe961dccc3474b0bb92a3e06-nehrw.png',
		name: 'Mumbai Flights',
		to: ['Goa', 'Delhi', 'Banglore', 'Ahmedabad'],
	},
	{
		image:
			'https://images.ixigo.com/image/upload/flightshome/79ee38cdbe961dccc3474b0bb92a3e06-nehrw.png',
		name: 'Mumbai Flights',
		to: ['Goa', 'Delhi', 'Banglore', 'Ahmedabad'],
	},
	{
		image:
			'https://images.ixigo.com/image/upload/flightshome/79ee38cdbe961dccc3474b0bb92a3e06-nehrw.png',
		name: 'Mumbai Flights',
		to: ['Goa', 'Delhi', 'Banglore', 'Ahmedabad'],
	},
	{
		image:
			'https://images.ixigo.com/image/upload/flightshome/79ee38cdbe961dccc3474b0bb92a3e06-nehrw.png',
		name: 'Mumbai Flights',
		to: ['Goa', 'Delhi', 'Banglore', 'Ahmedabad'],
	},
	{
		image:
			'https://images.ixigo.com/image/upload/flightshome/79ee38cdbe961dccc3474b0bb92a3e06-nehrw.png',
		name: 'Mumbai Flights',
		to: ['Goa', 'Delhi', 'Banglore', 'Ahmedabad'],
	},
	{
		image:
			'https://images.ixigo.com/image/upload/flightshome/79ee38cdbe961dccc3474b0bb92a3e06-nehrw.png',
		name: 'Mumbai Flights',
		to: ['Goa', 'Delhi', 'Banglore', 'Ahmedabad'],
	},
	{
		image:
			'https://images.ixigo.com/image/upload/flightshome/79ee38cdbe961dccc3474b0bb92a3e06-nehrw.png',
		name: 'Mumbai Flights',
		to: ['Goa', 'Delhi', 'Banglore', 'Ahmedabad'],
	},
	{
		image:
			'https://images.ixigo.com/image/upload/flightshome/79ee38cdbe961dccc3474b0bb92a3e06-nehrw.png',
		name: 'Mumbai Flights',
		to: ['Goa', 'Delhi', 'Banglore', 'Ahmedabad'],
	},
	{
		image:
			'https://images.ixigo.com/image/upload/flightshome/79ee38cdbe961dccc3474b0bb92a3e06-nehrw.png',
		name: 'Mumbai Flights',
		to: ['Goa', 'Delhi', 'Banglore', 'Ahmedabad'],
	},
	{
		image:
			'https://images.ixigo.com/image/upload/flightshome/79ee38cdbe961dccc3474b0bb92a3e06-nehrw.png',
		name: 'Mumbai Flights',
		to: ['Goa', 'Delhi', 'Banglore', 'Ahmedabad'],
	},
	{
		image:
			'https://images.ixigo.com/image/upload/flightshome/79ee38cdbe961dccc3474b0bb92a3e06-nehrw.png',
		name: 'Mumbai Flights',
		to: ['Goa', 'Delhi', 'Banglore', 'Ahmedabad'],
	},
	{
		image:
			'https://images.ixigo.com/image/upload/flightshome/79ee38cdbe961dccc3474b0bb92a3e06-nehrw.png',
		name: 'Mumbai Flights',
		to: ['Goa', 'Delhi', 'Banglore', 'Ahmedabad'],
	},
];
const slider = [
	'https://wallpapercave.com/wp/wp8030634.jpg',
	'https://images.pexels.com/photos/2305226/pexels-photo-2305226.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
	'https://images.pexels.com/photos/18201084/pexels-photo-18201084/free-photo-of-sky-tower-over-buildings-in-auckland-at-sunset.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
	'https://wallpapercave.com/wp/wp9388467.jpg',
];
const { RangePicker } = DatePicker;

const LandingPage = () => {
	const [options, setOptions] = useState([]);
	const [departDate, setDepartDate] = useState('');
	const [departDateReturn, setDepartDateReturn] = useState('');

	const dispatch = useDispatch();
	const theme = useTheme();
	const matches = useMediaQuery(theme.breakpoints.down('sm'));
	const { city } = useSelector((state) => state.home);
	const { depart, arrival, tab, topTab } = useSelector((state) => state.ui);
	const [loading, setLoading] = useState(false);
	const [open, setOpen] = useState(false);

	const showModal = () => {
		setOpen(true);
	};

	const handleOk = () => {
		setLoading(true);
		setTimeout(() => {
			setLoading(false);
			setOpen(false);
		}, 3000);
	};
	function disabledDate(current) {
		// Can not select days before today and today
		return current && current < moment().endOf('day');
	}
	const handleCancel = () => {
		setOpen(false);
	};
	const navigate = useNavigate();

	const onClick: MenuProps['onClick'] = ({ key }) => {
		message.info(`Click on item ${key}`);
	};
	useEffect(() => {
		let form = {};
		dispatch(fetchBusCityDispatch(form));
		dispatch(fetchHotel(form));
	}, []);
	console.log(
		'departDate',
		`${departDate.split('-')[0]}/${departDate.split('-')[1]}/${
			departDate.split('-')[2]
		}`
	);
	return (
		<div>
			<header className='App-header'>
				{/* <Header /> */}
				<Navbar />
				<SliderPage images={slider} />
				{/* <SliderPage */}

				<Box style={{ marginTop: 50 }}>
					<h1 style={{ textAlign: 'center', fontWeight: '500', fontSize: 40 }}>
						Best Flight Booking Offers
					</h1>
					<br></br>
					<br></br>
					<Carousels />
				</Box>
				<Container className='m'>
					<Box style={{ padding: 20 }}>
						<h1
							style={{ textAlign: 'center', color: '#EC5B24', marginTop: 20 }}>
							Best Flight Deals Of The Day
						</h1>
						<Grid
							container
							spacing={4}
							style={{ marginTop: 30, marginBottom: 30 }}>
							{popularDes.map((i) => {
								return (
									<Grid item xs={12} lg={4}>
										{' '}
										<Box style={{ display: 'flex', alignItems: 'center' }}>
											<img
												src={i.image}
												style={{ height: 45, width: 45, borderRadius: 25 }}
											/>
											<Box style={{ marginLeft: 10 }}>
												<span>{i.name}</span>
												<br />
												<span>To</span>:{' '}
												<span
													style={{
														color: 'orange',
														fontSize: 14,
														fontWeight: 500,
													}}>
													{i.to[0]}
												</span>{' '}
												<span
													style={{
														color: 'orange',
														fontSize: 14,
														fontWeight: 500,
														marginLeft: 5,
													}}>
													{i.to[1]}
												</span>
												<span
													style={{
														color: 'orange',
														fontSize: 14,
														fontWeight: 500,
														marginLeft: 5,
													}}>
													{i.to[2]}
												</span>
												<span
													style={{
														color: 'orange',
														fontSize: 14,
														fontWeight: 500,
														marginLeft: 5,
													}}>
													{i.to[3]}
												</span>
											</Box>
										</Box>
									</Grid>
								);
							})}
						</Grid>
					</Box>
				</Container>
				<Container className='m'>
					<Box style={{ padding: 20 }}>
						<h1
							style={{
								textAlign: 'center',
								color: '#EC5B24',
								marginTop: 20,
								fontSize: 26,
							}}>
							Popular Flight Routes
						</h1>
						<Grid
							container
							spacing={4}
							style={{ marginTop: 30, marginBottom: 30 }}>
							{popularDes.map((i) => {
								return (
									<Grid item xs={12} lg={4}>
										{' '}
										<Box style={{ display: 'flex', alignItems: 'center' }}>
											<img
												src={i.image}
												style={{ height: 45, width: 45, borderRadius: 25 }}
											/>
											<Box style={{ marginLeft: 10 }}>
												<span>{i.name}</span>
												<br />
												<span>To</span>:{' '}
												<span
													style={{
														color: 'orange',
														fontSize: 14,
														fontWeight: 500,
													}}>
													{i.to[0]}
												</span>{' '}
												<span
													style={{
														color: 'orange',
														fontSize: 14,
														fontWeight: 500,
														marginLeft: 5,
													}}>
													{i.to[1]}
												</span>
												<span
													style={{
														color: 'orange',
														fontSize: 14,
														fontWeight: 500,
														marginLeft: 5,
													}}>
													{i.to[2]}
												</span>
												<span
													style={{
														color: 'orange',
														fontSize: 14,
														fontWeight: 500,
														marginLeft: 5,
													}}>
													{i.to[3]}
												</span>
											</Box>
										</Box>
									</Grid>
								);
							})}
						</Grid>
					</Box>
				</Container>
				<Container className='m2'>
					<Box style={{ padding: 20 }}>
						<h1
							style={{
								textAlign: 'center',
								color: '#EC5B24',
								marginTop: 20,
								fontSize: 26,
							}}>
							Popular Domestic Airlines
						</h1>
						<Grid container spacing={2} style={{ marginTop: 30 }}>
							{popularFlight.map((i) => {
								return (
									<Grid item xs={6} lg={2}>
										<Box>
											<img src={i.image} />
											<br />
											<p style={{ marginTop: 15, fontSize: 12 }}>{i.name}</p>
										</Box>
									</Grid>
								);
							})}
						</Grid>
						{/* <Box
							style={{
								display: 'flex',
								justifyContent: 'space-between',
								marginTop: 50,
							}}>
							{popularFlight.map((i) => {
								return (
									<Box>
										<img src={i.image} />
										<br />
										<p style={{ marginTop: 15, fontSize: 12 }}>{i.name}</p>
									</Box>
								);
							})}
						</Box> */}
					</Box>
				</Container>

				<Footer />
			</header>
			<Login />
		</div>
	);
};

export default LandingPage;
